var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _vm._v("\n      Laden...\n    ")
          ])
        : _c(
            "div",
            [
              _c("div", { staticClass: "beschikbaarheden" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto" }, [
                    _c("h3", [_vm._v(_vm._s(_vm._f("date")(_vm.date)))])
                  ])
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c("h3", [_vm._v("Beschikbaarheid team traingingen")]),
                    _vm._v(" "),
                    _vm.AvailabilitiesGroepssessies.length == 0
                      ? _c("span", { staticClass: "mb-3 d-block" }, [
                          _vm._v("Nog geen beschikbaarheid opgegeven.")
                        ])
                      : _vm._l(_vm.AvailabilitiesGroepssessies, function(
                          availabilitie,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _c("div", { staticClass: "beschikbaarheid" }, [
                              _c(
                                "div",
                                { staticClass: "row align-items-center" },
                                [
                                  _c("div", { staticClass: "col-12 col-md" }, [
                                    _c(
                                      "div",
                                      { staticClass: "form-group mb-4" },
                                      [
                                        _c("label", [_vm._v("Vanaf")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: availabilitie.start,
                                              expression: "availabilitie.start"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text", readonly: "" },
                                          domProps: {
                                            value: availabilitie.start
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                availabilitie,
                                                "start",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-12 col-md" }, [
                                    _c(
                                      "div",
                                      { staticClass: "form-group mb-4" },
                                      [
                                        _c("label", [_vm._v("Tot")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: availabilitie.end,
                                              expression: "availabilitie.end"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text", readonly: "" },
                                          domProps: {
                                            value: availabilitie.end
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                availabilitie,
                                                "end",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-auto" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary btn-icon",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              _vm.openEditDate =
                                                availabilitie.id
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticStyle: {
                                                "enable-background":
                                                  "new 0 0 512 512",
                                                width: "14px"
                                              },
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                "xmlns:xlink":
                                                  "http://www.w3.org/1999/xlink",
                                                "xmlns:svgjs":
                                                  "http://svgjs.com/svgjs",
                                                version: "1.1",
                                                width: "512",
                                                height: "512",
                                                x: "0",
                                                y: "0",
                                                viewBox: "0 0 492.49284 492",
                                                "xml:space": "preserve"
                                              }
                                            },
                                            [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    d:
                                                      "m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0",
                                                    fill: "#ffffff",
                                                    "data-original": "#000000"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    d:
                                                      "m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0",
                                                    fill: "#ffffff",
                                                    "data-original": "#000000"
                                                  }
                                                })
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        on: {
                          click: function($event) {
                            return _vm.handleOpenNewGroepDate()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn btn-primary btn-icon d-inline-flex mr-2"
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 9 10",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M8.35714 4.0625H5.46429V1.25C5.46429 0.904883 5.17641 0.625 4.82143 0.625H4.17857C3.82359 0.625 3.53571 0.904883 3.53571 1.25V4.0625H0.642857C0.287879 4.0625 0 4.34238 0 4.6875V5.3125C0 5.65762 0.287879 5.9375 0.642857 5.9375H3.53571V8.75C3.53571 9.09512 3.82359 9.375 4.17857 9.375H4.82143C5.17641 9.375 5.46429 9.09512 5.46429 8.75V5.9375H8.35714C8.71212 5.9375 9 5.65762 9 5.3125V4.6875C9 4.34238 8.71212 4.0625 8.35714 4.0625Z"
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v("\n            Tijdslot toevoegen\n          ")
                      ]
                    ),
                    _vm._v(" "),
                    _vm.openNewGroepDate
                      ? _c("NewDate", {
                          attrs: {
                            date: _vm.date,
                            expert: _vm.expert,
                            ajax: _vm.ajax,
                            type: "groepssessie"
                          }
                        })
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c("h3", [_vm._v("Beschikbaarheid open inschrijving")]),
                    _vm._v(" "),
                    _vm.AvailabilitiesIndividueels.length == 0
                      ? _c("span", { staticClass: "mb-3 d-block" }, [
                          _vm._v("Nog geen beschikbaarheid opgegeven.")
                        ])
                      : _vm._l(_vm.AvailabilitiesIndividueels, function(
                          availabilitie,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _c("div", { staticClass: "beschikbaarheid" }, [
                              _c(
                                "div",
                                { staticClass: "row align-items-center" },
                                [
                                  _c("div", { staticClass: "col-12 col-md" }, [
                                    _c(
                                      "div",
                                      { staticClass: "form-group mb-4" },
                                      [
                                        _c("label", [_vm._v("Training")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: availabilitie.session,
                                              expression:
                                                "availabilitie.session"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text", readonly: "" },
                                          domProps: {
                                            value: availabilitie.session
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                availabilitie,
                                                "session",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group mb-4" },
                                        [
                                          _c("label", [_vm._v("Vanaf")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: availabilitie.start,
                                                expression:
                                                  "availabilitie.start"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value: availabilitie.start
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  availabilitie,
                                                  "start",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group mb-4" },
                                        [
                                          _c("label", [_vm._v("Tot")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: availabilitie.end,
                                                expression: "availabilitie.end"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              readonly: ""
                                            },
                                            domProps: {
                                              value: availabilitie.end
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  availabilitie,
                                                  "end",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-auto" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary btn-icon",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              _vm.openEditDate =
                                                availabilitie.id
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticStyle: {
                                                "enable-background":
                                                  "new 0 0 512 512",
                                                width: "14px"
                                              },
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                "xmlns:xlink":
                                                  "http://www.w3.org/1999/xlink",
                                                "xmlns:svgjs":
                                                  "http://svgjs.com/svgjs",
                                                version: "1.1",
                                                width: "512",
                                                height: "512",
                                                x: "0",
                                                y: "0",
                                                viewBox: "0 0 492.49284 492",
                                                "xml:space": "preserve"
                                              }
                                            },
                                            [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    d:
                                                      "m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0",
                                                    fill: "#ffffff",
                                                    "data-original": "#000000"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    d:
                                                      "m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0",
                                                    fill: "#ffffff",
                                                    "data-original": "#000000"
                                                  }
                                                })
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        on: {
                          click: function($event) {
                            return _vm.handleOpenNewOpenDate()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn btn-primary btn-icon d-inline-flex mr-2"
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 9 10",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M8.35714 4.0625H5.46429V1.25C5.46429 0.904883 5.17641 0.625 4.82143 0.625H4.17857C3.82359 0.625 3.53571 0.904883 3.53571 1.25V4.0625H0.642857C0.287879 4.0625 0 4.34238 0 4.6875V5.3125C0 5.65762 0.287879 5.9375 0.642857 5.9375H3.53571V8.75C3.53571 9.09512 3.82359 9.375 4.17857 9.375H4.82143C5.17641 9.375 5.46429 9.09512 5.46429 8.75V5.9375H8.35714C8.71212 5.9375 9 5.65762 9 5.3125V4.6875C9 4.34238 8.71212 4.0625 8.35714 4.0625Z"
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v("\n            Tijdslot toevoegen\n          ")
                      ]
                    ),
                    _vm._v(" "),
                    _vm.openNewOpenDate
                      ? _c("NewDate", {
                          attrs: {
                            date: _vm.date,
                            expert: _vm.expert,
                            ajax: _vm.ajax,
                            type: "individueel",
                            sessions: _vm.sessions
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br")
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm.openEditDate !== ""
                ? _c("EditDate", {
                    attrs: {
                      availability: _vm.openEditDate,
                      ajax: _vm.ajax,
                      sessions: _vm.sessions
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "sessies mt-4" }, [
                _vm._m(1),
                _vm._v(" "),
                _vm.bookings.length == 0
                  ? _c("span", { staticClass: "mb-3 d-block" }, [
                      _vm._v("Nog geen tafelsessie geboekt.")
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "accordion mt-2",
                        attrs: { id: "accordionBooking" }
                      },
                      _vm._l(_vm.bookings, function(booking, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "card mt-2" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "card-header",
                                attrs: { id: "heading" + index }
                              },
                              [
                                _c("h2", { staticClass: "mb-0" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-link btn-block text-left",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "collapse",
                                        "data-target": "#collapse" + index,
                                        "aria-expanded": "true",
                                        "aria-controls": "collapseOne"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(booking.title) +
                                              "\n                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-auto mr-4" },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "14",
                                                  height: "14",
                                                  viewBox: "0 0 14 14",
                                                  fill: "#21386e",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125Z",
                                                    fill: "#21386e"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M9.72969 8.97812L7.50156 7.36719V3.5C7.50156 3.43125 7.44531 3.375 7.37656 3.375H6.625C6.55625 3.375 6.5 3.43125 6.5 3.5V7.80313C6.5 7.84375 6.51875 7.88125 6.55156 7.90469L9.13594 9.78906C9.19219 9.82969 9.27031 9.81719 9.31094 9.7625L9.75781 9.15312C9.79844 9.09531 9.78594 9.01719 9.72969 8.97812Z",
                                                    fill: "#21386e"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(booking.time_start) +
                                                " - " +
                                                _vm._s(booking.time_end) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collapse",
                                attrs: {
                                  id: "collapse" + index,
                                  "aria-labelledby": "heading" + index,
                                  "data-parent": "#accordionBooking"
                                }
                              },
                              [
                                _c("div", { staticClass: "card-body" }, [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "div",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Geboekt door")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "Naam: " +
                                            _vm._s(booking.booking_first_name) +
                                            " " +
                                            _vm._s(booking.booking_last_name)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "Email: " +
                                            _vm._s(booking.booking_email)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "Telefoonnummer: " +
                                            _vm._s(booking.booking_phone)
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
              ])
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("h2", [_vm._v("Beschikbaarheid")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("*Per tijdslot moet je minimaal 90 minuten beschikbaar zijn")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h2", [_vm._v("Geboekte sessies")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Agenda/Date.vue?vue&type=template&id=6ddade6d&
// module id = 414
// module chunks = 0